if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      static MOBILE_MODAL_MQ = '(max-width: 749px)';
      static REDUCED_MOTION_MQ = '(prefers-reduced-motion: reduce)';

      shouldAnimateMobileModal() {
        return (
          window.matchMedia(ProductModal.MOBILE_MODAL_MQ).matches &&
          !window.matchMedia(ProductModal.REDUCED_MOTION_MQ).matches
        );
      }

      hide() {
        if (
          !this.hasAttribute('open') ||
          this.classList.contains('product-media-modal--closing') ||
          !this.shouldAnimateMobileModal()
        ) {
          super.hide();
          return;
        }

        this.classList.add('product-media-modal--closing');
        const dialog = this.querySelector('.product-media-modal__dialog');
        let finished = false;

        const finish = () => {
          if (finished) return;
          finished = true;
          dialog?.removeEventListener('transitionend', onTransitionEnd);
          this.classList.remove('product-media-modal--closing');
          super.hide();
        };

        const onTransitionEnd = (event) => {
          if (event.target !== dialog) return;
          finish();
        };

        dialog?.addEventListener('transitionend', onTransitionEnd);
        window.setTimeout(finish, 450);
      }

      show(opener) {
        this.classList.remove('product-media-modal--closing');
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
